export const CONTACT_OPEN_EVENT = "dsite:open-contact";

export function isContactHref(href) {
  if (!href) return false;
  const normalized = String(href).trim().toLowerCase();
  return (
    normalized === "#contact" ||
    normalized === "/#contact" ||
    normalized.endsWith("#contact")
  );
}

export function openContactForm(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(CONTACT_OPEN_EVENT));
}

export function handleContactClick(event, href) {
  if (!isContactHref(href)) return false;
  openContactForm(event);
  return true;
}
